module.exports = require("@material-ui/core/ListSubheader");